var e = "Principal",
  o = "Seleccionar rango de fechas",
  n = "Seleccionar fecha",
  t = "AAAA-MM-DD",
  a = "Hoy",
  c = "Ayer",
  _ = "Esta semana",
  l = "Últimos 7 días",
  m = "Últimos 30 días",
  r = "La semana pasada",
  p = "Este mes",
  i = "El mes pasado",
  s = "Este año",
  d = "El año pasado",
  b = "Esta fecha no es válida. Por favor intente nuevamente.",
  L = "Enero",
  P = "Febrero",
  u = "Marzo",
  y = "Abril",
  k = "Mayo",
  M = "Junio",
  F = "Julio",
  g = "Agosto",
  h = "Septiembre",
  S = "Octubre",
  T = "Noviembre",
  v = "Diciembre",
  f = "L",
  H = "M",
  x = "X",
  V = "J",
  C = "V",
  E = "S",
  K = "D",
  N = "Seleccionar todo",
  I = "Seleccionar",
  B = "Mostrando",
  D = "de",
  A = "Filas por página",
  O = "{{x}} seleccionados",
  R = "Todo seleccionado",
  W = "Cancelar",
  Y = "Guardar",
  J = "Eliminar",
  w = "No se han encontrado coincidencias en la búsqueda.",
  U = "Buscar…",
  z = "¿Quiere abandonar la página? Algunos cambios pueden no haber sido guardados.",
  q = "Este campo no puede estar vacío.",
  G = "Algo salió mal.",
  j = "Ingresar hora",
  Q = "Ingresar rango de horas",
  X = "HH:MM",
  Z = "HH:MM — HH:MM",
  $ = "HH:MM:SS",
  ee = "HH:MM:SS — HH:MM:SS",
  oe = "Ingrese nombre",
  ne = "Suelte el archivo para cargarlo",
  te = "Suelte el archivo aquí o",
  ae = "Seleccionar...",
  ce = "navegar",
  _e = "Cargando",
  le = "Hecho",
  me = "Copiar",
  re = "Copiado",
  pe = "Sin resultados",
  ie = "Guardar tarjeta",
  se = "Pago rápido",
  de = "PayPal",
  be = "Ingrese número",
  Le = "Hacer primario",
  Pe = "Rechazar",
  ue = "Contestar",
  ye = "Confirmado",
  ke = "No confirmado",
  Me = "Agregar variable personalizada",
  Fe = "Variables del sistema",
  ge = "Variables personalizadas",
  he = "Variables",
  Se = "La variable es inválida o no existe.",
  Te = "Nombre de variable",
  ve = "Esta variable ya existe. Por favor intente con otra.",
  fe = "Tipo",
  He = "Cadena: hasta 4096 caracteres",
  xe = "Número: hasta 255 dígitos",
  Ve = "Datetime: en formato YYYY-MM-DD HH:MM:SS\n",
  Ce = "Cadena",
  Ee = "Número",
  Ke = "Datetime",
  Ne = "Agregar",
  Ie = {
    billing_paymentSettingsTab_savedCardsSection_primarySavedCardLabel: e,
    component_component_calendarPickerPromptLabel_datesFilterPrompt: o,
    component_component_calendarPickerPromptLabel_dateFilterPrompt: n,
    component_component_calendarPickerLabel_datesFilterDateRange: t,
    component_component_calendarPickerLabel_datesFilterToday: a,
    component_component_calendarPickerLabel_datesFilterYesterday: c,
    component_component_calendarPickerLabel_datesFilterThisWeek: _,
    component_component_calendarPickerLabel_datesFilterLast7Days: l,
    component_component_calendarPickerLabel_datesFilterLast30Days: m,
    component_component_calendarPickerLabel_datesFilterLastWeek: r,
    component_component_calendarPickerLabel_datesFilterThisMonth: p,
    component_component_calendarPickerLabel_datesFilterLastMonth: i,
    component_component_calendarPickerLabel_datesFilterThisYear: s,
    component_component_calendarPickerLabel_datesFilterLastYear: d,
    component_commonKeys_dateInvalidError: b,
    component_component_calendarPickerLabel_datesFilterJanuary: L,
    component_component_calendarPickerLabel_datesFilterFebruary: P,
    component_component_calendarPickerLabel_datesFilterMarch: u,
    component_component_calendarPickerLabel_datesFilterApril: y,
    component_component_calendarPickerLabel_datesFilterMay: k,
    component_component_calendarPickerLabel_datesFilterJune: M,
    component_component_calendarPickerLabel_datesFilterJuly: F,
    component_component_calendarPickerLabel_datesFilterAugust: g,
    component_component_calendarPickerLabel_datesFilterSeptember: h,
    component_component_calendarPickerLabel_datesFilterOctober: S,
    component_component_calendarPickerLabel_datesFilterNovember: T,
    component_component_calendarPickerLabel_datesFilterDecember: v,
    component_component_calendarPickerLabel_datesFilterMonday: f,
    component_component_calendarPickerLabel_datesFilterTuesday: H,
    component_component_calendarPickerLabel_datesFilterWednesday: x,
    component_component_calendarPickerLabel_datesFilterThursday: V,
    component_component_calendarPickerLabel_datesFilterFriday: C,
    component_component_calendarPickerLabel_datesFilterSaturday: E,
    component_component_calendarPickerLabel_datesFilterSunday: K,
    component_component_checkboxSelectOption_selectAllOption: N,
    component_component_checkboxSelectPromptLabel_selectLabel: I,
    component_component_paginatorInfoLabel_showing: B,
    component_component_paginatorInfoLabel_outOf: D,
    component_component_paginatorStepChangerLabel_perPageLabel: A,
    component_component_checkboxSelectLabel_selectedLabel: O,
    component_component_checkboxSelectLabel_allSelectedLabel: R,
    component_commonKeys_cancelButton_cancelButton: W,
    component_commonKeys_saveButton_saveButton: Y,
    component_commonKeys_deleteIcon_deleteIconButton: J,
    component_commonMessage_searchMessageLabel_noMatchingSearchMessageLabel: w,
    component_commonKeys_textPromptLabel_searchEllipsisPromptLabel: U,
    component_commonKeys_leavePagePrompt_leavePagePrompt: z,
    component_commonKeys_inputPromptLabel_fieldCannotBeEmptyError: q,
    component_notification_notificationLabel_somethingWentWrongLabel: G,
    component_component_timePickerPromptLabel_selectTime: j,
    component_component_timePickerPromptLabel_selectRangeTime: Q,
    component_component_timePickerPromptLabel_selectHHMM: X,
    component_component_timePickerPromptLabel_selectRangeHHMM: Z,
    component_component_timePickerPromptLabel_selectHHMMSS: $,
    component_component_timePickerPromptLabel_selectRangeHHMMSS: ee,
    component_enterTextField_textPromptLabel_enterNamePromptLabel: oe,
    component_fileUpload_uploadPrompt_dropFileToUploadLabel: ne,
    component_fileUpload_uploadPrompt_dropFileHereLabel: te,
    component_commonKeys_textPromptLabel_selectEllipsisPromptLabel: ae,
    component_commonKeys_buttonLabel_browseButton: ce,
    component_commonKeys_loadingLabel_loadingLabel: _e,
    component_commonKeys_doneLabel_doneLabel: le,
    component_component_copyLabel_copyTooltip: me,
    component_component_copiedLabel_copiedTooltip: re,
    component_searchItemMenu_noSearchResults_noResultsLabel: pe,
    component_component_paymentMethod_savedCardLabel: ie,
    component_component_paymentMethod_expressCheckoutLabel: se,
    component_component_paymentMethod_PayPalLabel: de,
    component_commonKeys_creditCardInformationPrompt_enterNumberLabel: be,
    component_commonKeys_selectTooltip_makePrimaryTooltip: Le,
    component_interactionNotification_buttonLabel_declineButtonLabel: Pe,
    component_interactionNotification_buttonLabel_answerButtonLabel: ue,
    component_component_input_emailConfirmed: ye,
    component_component_input_emailNotConfirmed: ke,
    component_component_popupMenu_addCustomVariableLabel: Me,
    component_component_popupMenu_systemVariablesLabel: Fe,
    component_component_popupMenu_customVariablesLabel: ge,
    component_component_variableIcon_variableIconTooltipLabel: he,
    component_component_variableError_invalidFormatLabel: Se,
    component_component_addVariableModal_variableNameLabel: Te,
    component_component_addVariableModal_variableExistsErrorLabel: ve,
    component_component_addVariableModal_typeLabel: fe,
    component_component_addVariableModal_typeTooltipStringText: He,
    component_component_addVariableModal_typeTooltipNumberText: xe,
    component_component_addVariableModal_typeTooltipDatetimeText: Ve,
    component_component_addVariableModal_typeStringOption: Ce,
    component_component_addVariableModal_typeNumberOption: Ee,
    component_component_addVariableModal_typeDatetimeOption: Ke,
    component_component_addVariableModal_addButtonLabel: Ne
  };
export { e as billing_paymentSettingsTab_savedCardsSection_primarySavedCardLabel, ce as component_commonKeys_buttonLabel_browseButton, W as component_commonKeys_cancelButton_cancelButton, be as component_commonKeys_creditCardInformationPrompt_enterNumberLabel, b as component_commonKeys_dateInvalidError, J as component_commonKeys_deleteIcon_deleteIconButton, le as component_commonKeys_doneLabel_doneLabel, q as component_commonKeys_inputPromptLabel_fieldCannotBeEmptyError, z as component_commonKeys_leavePagePrompt_leavePagePrompt, _e as component_commonKeys_loadingLabel_loadingLabel, Y as component_commonKeys_saveButton_saveButton, Le as component_commonKeys_selectTooltip_makePrimaryTooltip, U as component_commonKeys_textPromptLabel_searchEllipsisPromptLabel, ae as component_commonKeys_textPromptLabel_selectEllipsisPromptLabel, w as component_commonMessage_searchMessageLabel_noMatchingSearchMessageLabel, Ne as component_component_addVariableModal_addButtonLabel, Ke as component_component_addVariableModal_typeDatetimeOption, fe as component_component_addVariableModal_typeLabel, Ee as component_component_addVariableModal_typeNumberOption, Ce as component_component_addVariableModal_typeStringOption, Ve as component_component_addVariableModal_typeTooltipDatetimeText, xe as component_component_addVariableModal_typeTooltipNumberText, He as component_component_addVariableModal_typeTooltipStringText, ve as component_component_addVariableModal_variableExistsErrorLabel, Te as component_component_addVariableModal_variableNameLabel, y as component_component_calendarPickerLabel_datesFilterApril, g as component_component_calendarPickerLabel_datesFilterAugust, t as component_component_calendarPickerLabel_datesFilterDateRange, v as component_component_calendarPickerLabel_datesFilterDecember, P as component_component_calendarPickerLabel_datesFilterFebruary, C as component_component_calendarPickerLabel_datesFilterFriday, L as component_component_calendarPickerLabel_datesFilterJanuary, F as component_component_calendarPickerLabel_datesFilterJuly, M as component_component_calendarPickerLabel_datesFilterJune, m as component_component_calendarPickerLabel_datesFilterLast30Days, l as component_component_calendarPickerLabel_datesFilterLast7Days, i as component_component_calendarPickerLabel_datesFilterLastMonth, r as component_component_calendarPickerLabel_datesFilterLastWeek, d as component_component_calendarPickerLabel_datesFilterLastYear, u as component_component_calendarPickerLabel_datesFilterMarch, k as component_component_calendarPickerLabel_datesFilterMay, f as component_component_calendarPickerLabel_datesFilterMonday, T as component_component_calendarPickerLabel_datesFilterNovember, S as component_component_calendarPickerLabel_datesFilterOctober, E as component_component_calendarPickerLabel_datesFilterSaturday, h as component_component_calendarPickerLabel_datesFilterSeptember, K as component_component_calendarPickerLabel_datesFilterSunday, p as component_component_calendarPickerLabel_datesFilterThisMonth, _ as component_component_calendarPickerLabel_datesFilterThisWeek, s as component_component_calendarPickerLabel_datesFilterThisYear, V as component_component_calendarPickerLabel_datesFilterThursday, a as component_component_calendarPickerLabel_datesFilterToday, H as component_component_calendarPickerLabel_datesFilterTuesday, x as component_component_calendarPickerLabel_datesFilterWednesday, c as component_component_calendarPickerLabel_datesFilterYesterday, n as component_component_calendarPickerPromptLabel_dateFilterPrompt, o as component_component_calendarPickerPromptLabel_datesFilterPrompt, R as component_component_checkboxSelectLabel_allSelectedLabel, O as component_component_checkboxSelectLabel_selectedLabel, N as component_component_checkboxSelectOption_selectAllOption, I as component_component_checkboxSelectPromptLabel_selectLabel, re as component_component_copiedLabel_copiedTooltip, me as component_component_copyLabel_copyTooltip, ye as component_component_input_emailConfirmed, ke as component_component_input_emailNotConfirmed, D as component_component_paginatorInfoLabel_outOf, B as component_component_paginatorInfoLabel_showing, A as component_component_paginatorStepChangerLabel_perPageLabel, de as component_component_paymentMethod_PayPalLabel, se as component_component_paymentMethod_expressCheckoutLabel, ie as component_component_paymentMethod_savedCardLabel, Me as component_component_popupMenu_addCustomVariableLabel, ge as component_component_popupMenu_customVariablesLabel, Fe as component_component_popupMenu_systemVariablesLabel, X as component_component_timePickerPromptLabel_selectHHMM, $ as component_component_timePickerPromptLabel_selectHHMMSS, Z as component_component_timePickerPromptLabel_selectRangeHHMM, ee as component_component_timePickerPromptLabel_selectRangeHHMMSS, Q as component_component_timePickerPromptLabel_selectRangeTime, j as component_component_timePickerPromptLabel_selectTime, Se as component_component_variableError_invalidFormatLabel, he as component_component_variableIcon_variableIconTooltipLabel, oe as component_enterTextField_textPromptLabel_enterNamePromptLabel, te as component_fileUpload_uploadPrompt_dropFileHereLabel, ne as component_fileUpload_uploadPrompt_dropFileToUploadLabel, ue as component_interactionNotification_buttonLabel_answerButtonLabel, Pe as component_interactionNotification_buttonLabel_declineButtonLabel, G as component_notification_notificationLabel_somethingWentWrongLabel, pe as component_searchItemMenu_noSearchResults_noResultsLabel, Ie as default };